import type { PreloadedQuery } from 'react-relay';
import QUERY, {
	type PermissionSchemesQuery,
} from '@jira/permissions-administration__pages-permission-scheme/src/ui/__generated__/PermissionSchemesQuery.graphql';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';

export const permissionSchemePageResource: RouteResource<
	PreloadedQuery<PermissionSchemesQuery, Record<string, unknown>>
> = createRelayResource<PermissionSchemesQuery>({
	type: RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			// To Do: use ari-typescript library once it is approved
			// https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
			schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${
				tenantContext.activationId
			}/${String(match.params.schemeId)}`,
		},
		options: { fetchPolicy: 'network-only' },
	}),
});
